const cnfsdNav = (function () {
	let nav, navBackdropMask, menuButton, menuButtonIcon, menuButtonTitle, skipNav, closeProductNavButtons;

	const init = () => {
		skipNav = document.getElementById('skip-nav-link');
		nav = document.querySelector('.cnf_nav');
		navBackdropMask = document.querySelector('.cnf_nav-mask');
		menuButton = document.querySelector('.cnf_mobile-menu-button');
		menuButtonIcon = menuButton ? menuButton.querySelector('.cnf_mobile-menu-icon') : null;
		menuButtonTitle = menuButton ? menuButton.querySelector('.cnf_mobile-menu-title') : null;
		closeProductNavButtons = nav ? nav.querySelectorAll('.cnf_nav-product-close') : null;

		if (nav) {
			eventListeners();
		}
	};

	// Add event listeners
	const eventListeners = () => {
		if (menuButton) {
			menuButton.addEventListener('click', e => {
				e.preventDefault();
				toggleNav();
			});
		}

		if (closeProductNavButtons) {
			closeProductNavButtons.forEach(button => {
				button.addEventListener('click', () => {
					closeProductNav();
				});
			});
		}

		if (skipNav) {
			skipNav.addEventListener('click', function () {
				toggleNav();
			});
		}

		if (navBackdropMask) {
			navBackdropMask.addEventListener('click', function () {
				toggleNav();
				navBackdropMask.classList.remove('cnf_nav-mask--open');
			});
		}
	};

	// Toggle nav visibility for mobile
	const toggleNav = () => {
		if (nav) {
			if (menuButton) {
				if (menuButton.classList.contains('cnf_mobile-menu-button--open')) {
					menuButton.classList.remove('cnf_mobile-menu-button--open');
					menuButtonTitle.textContent = 'Menu';
					nav.setAttribute('aria-expanded', false);
				} else {
					menuButton.classList.add('cnf_mobile-menu-button--open');
					menuButtonTitle.textContent = 'Close';
					nav.setAttribute('aria-expanded', true);
				}
			}
			nav.classList.toggle('cnf_nav--open');
			closeProductNav();
		}
	};

	// Handle search click event & remove [open] attribute from all products
	const closeProductNav = () => {
		const products = document.querySelectorAll('.cnf_nav-product');
		products.forEach(product => {
			if (product) {
				product.removeAttribute('open');
			}
		});
	};

	return {
		init: init,
	};
})();

// Initialize when the DOM is fully loaded
document.addEventListener('DOMContentLoaded', function () {
	cnfsdNav.init();
});

// Export the created object for Node.js/Jest environments
if (typeof module !== 'undefined' && module.exports) {
	module.exports = cnfsdNav;
}
